"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginatedRequest = exports.paginatedResult = void 0;
const zod_1 = require("zod");
function paginatedResult(itemType) {
    return zod_1.z.object({
        total: zod_1.z.number().int().nonnegative(),
        from: zod_1.z.number().int().nonnegative(),
        results: zod_1.z.array(itemType),
    });
}
exports.paginatedResult = paginatedResult;
const paginatedRequest = (filter) => {
    return zod_1.z.object(filter).extend({
        size: zod_1.z.number().int().positive(),
        from: zod_1.z.number().int().nonnegative(),
    });
};
exports.paginatedRequest = paginatedRequest;
